import { render } from "./Consultancy.vue?vue&type=template&id=52cbac5e&scoped=true"
import script from "./Consultancy.vue?vue&type=script&lang=js"
export * from "./Consultancy.vue?vue&type=script&lang=js"

import "./Consultancy.vue?vue&type=style&index=0&id=52cbac5e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cbac5e"]])

export default __exports__